var Utils = require("./utils");
var queryArray = Utils.queryArray;

var form = document.querySelector("form.form");
var formId = form && form.id;
var formFields = queryArray("input, select, textarea", form);

var applicants = [];
var contacts = [];
var locations = [];

function getApplicants() {
  return applicants;
}
function getContacts() {
  return contacts;
}
function getLocations() {
  return locations;
}

// // remove typeFormFields from the general formFields
formFields = filterTypeFormFields(formFields);

function filterTypeFormFields(fields) {
  var typeFormFields = queryArray(
    ".type-form input, .type-form select, .type-form textarea"
  );
  return fields
    .filter(function (el) {
      return typeFormFields.indexOf(el) === -1;
    })
    .filter(Boolean);
}

// add button opens an empty type form; cancel closes type form
var addBtns = queryArray(".type-btn");
addBtns.forEach(function (btn) {
  btn.classList.add("active");
  btn.addEventListener("click", function () {
    toggleTypeForm(this.getAttribute("data-type"), true);
  });
});
var cancelBtns = queryArray(".action-btn[data-action='cancel']");
cancelBtns.forEach(function (btn) {
  btn.addEventListener("click", function () {
    const type = this.getAttribute("data-type");
    toggleTypeForm(type, false);
  });
});
// save button adds item to lists
var saveBtns = queryArray(".action-btn[data-action='save']");
saveBtns.forEach(function (btn) {
  btn.addEventListener("click", function () {
    const type = this.getAttribute("data-type");
    saveTypeItem(type);
    toggleTypeForm(type, false);
    formHelpers.updateFromLocalStorage(formFields);
  });
});

function toggleTypeForm(type, setActive) {
  var form = document.querySelector(".type-form[data-type='" + type + "']");
  var btn = document.querySelector(".type-btn[data-type='" + type + "']");

  if (setActive) {
    form.classList.add("active");
    btn.classList.remove("active");
  } else {
    clearTypeForm(type);
    form.classList.remove("active");
    btn.classList.add("active");
  }
}
function clearTypeForm(type) {
  var form = document.querySelector(".type-form[data-type='" + type + "']");
  var typeFormFields = queryArray("input, select, textarea", form);
  typeFormFields.forEach(function (field) {
    if (field.type == "checkbox") {
      field.checked = false;
    } else if (
      field.type == "select-multiple" ||
      field.type == "select-single"
    ) {
      field.selectize.setValue([], true);
      var options = queryArray("option", field);
      options.forEach(function (option) {
        option.selected = false;
      });
    } else {
      field.value = "";
    }
  });
  var saveBtn = document.querySelector(
    ".type-form[data-type='" + type + "'] .action-btn[data-action='save']"
  );
  saveBtn.removeAttribute("data-timestamp");
}
function saveTypeItem(type) {
  var form = document.querySelector(".type-form[data-type='" + type + "']");
  var typeFormFields = queryArray("input, select, textarea", form);
  var data = {};
  typeFormFields.forEach(function (field) {
    if (field.type == "checkbox") {
      data[field.id] = field.checked;
    } else if (field.type == "select-multiple") {
      var options = [];
      $(field)
        .find("option:selected")
        .each(function () {
          options.push($(this).val());
        });
      data[field.id] = options;
    } else {
      data[field.id] = field.value;
    }
  });

  // Add item to list view & to appropriate array
  var saveBtn = document.querySelector(
    ".type-form[data-type='" + type + "'] .action-btn[data-action='save']"
  );
  var editTimestamp = saveBtn.getAttribute("data-timestamp");
  if (editTimestamp) {
    appendToLists(data, editTimestamp, type);
  } else {
    appendToLists(data, +new Date(), type);
  }
}

function editTypeItem(type, timestamp) {
  var data;
  var form = document.querySelector(".type-form[data-type='" + type + "']");
  if (type == "applicant") {
    const applicant = applicants.filter(function (c) {
      return c && c.timestamp == timestamp;
    })[0];
    const index = $(applicants).index(applicant);
    data = applicants[index].data;
  } else if (type == "contact") {
    const contact = contacts.filter(function (c) {
      return c && c.timestamp == timestamp;
    })[0];
    const index = $(contacts).index(contact);
    data = contacts[index].data;
  } else if (type == "location") {
    const location = locations.filter(function (l) {
      return l && l.timestamp == timestamp;
    })[0];
    const index = $(locations).index(location);
    data = locations[index].data;
  }
  // populate the data from the correct list type (contact/location) to the form
  var typeFormFields = queryArray("input, select, textarea", form);
  typeFormFields.forEach(function (field) {
    if (field.type == "checkbox") {
      field.checked = data[field.id];
    } else if (field.type == "select-multiple") {
      field.selectize.setValue(data[field.id], true);
    } else {
      field.value = data[field.id];
    }
  });

  var saveBtn = document.querySelector(
    ".type-form[data-type='" + type + "'] .action-btn[data-action='save']"
  );
  saveBtn.setAttribute("data-timestamp", timestamp);
}

function deleteItemFromLists(timestamp) {
  var link = document.querySelector(
    ".type-list a[data-timestamp='" + timestamp + "']"
  );
  if (link && link.parentElement) {
    var parentRow = link.parentElement.parentElement;
    $(parentRow).remove();
  }
}

function appendToLists(data, timestamp, type) {
  var var1, var2, var3;
  if (type == "applicant") {
    var1 = data.firstName + " " + data.lastName;
    var2 = data.email || "";
    var3 = data.phone || "";

    const contact = applicants.filter(function (c) {
      return c && c.timestamp == timestamp;
    })[0];
    const index = $(applicants).index(contact);
    if (index == -1) {
      applicants.push({ timestamp: timestamp.toString(), data: data });
    } else {
      deleteItemFromLists(timestamp);
      applicants[index] = { timestamp: timestamp.toString(), data: data };
    }
    localStorage.setItem(formId + "-applicants", JSON.stringify(applicants));
  } else if (type == "contact") {
    var1 = data.contactFirstName + " " + data.contactLastName;
    var2 = data.contactEmail;
    var3 = data.contactAuthorizedRepresentative ? "✓" : "";

    const contact = contacts.filter(function (c) {
      return c && c.timestamp == timestamp;
    })[0];
    const index = $(contacts).index(contact);
    if (index == -1) {
      contacts.push({ timestamp: timestamp.toString(), data: data });
    } else {
      deleteItemFromLists(timestamp);
      contacts[index] = { timestamp: timestamp.toString(), data: data };
    }
    localStorage.setItem(formId + "-contacts", JSON.stringify(contacts));
  } else if (type == "location") {
    var1 = data.locationName;
    var2 =
      data.locationCity +
      ", " +
      data.locationState +
      ", " +
      data.locationCountry;
    var3 = data.locationNumEmployees;
    const location = locations.filter(function (l) {
      return l && l.timestamp == timestamp;
    })[0];
    const index = $(locations).index(location);
    if (index == -1) {
      locations.push({ timestamp: timestamp.toString(), data: data });
    } else {
      deleteItemFromLists(timestamp);
      locations[index] = { timestamp: timestamp.toString(), data: data };
    }
    localStorage.setItem(formId + "-locations", JSON.stringify(locations));
  }
  createRow(type, timestamp, var1, var2, var3, rowStatus);
}

function createRow(type, timestamp, var1, var2, var3, rowStatus) {
  var list = document.querySelector(".type-list[data-type='" + type + "']");
  var row = document.createElement("div");
  row.classList.add("row");
  if (rowStatus != "") row.classList.add(rowStatus);

  var el1 = document.createElement("div");
  el1.innerHTML = var1;

  var el2 = document.createElement("div");
  el2.innerHTML = var2;

  var el3 = document.createElement("div");
  el3.innerHTML = var3;

  var el4 = document.createElement("div");

  var validLink = document.createElement("a");
  validLink.classList.add("valid");
  validLink.setAttribute("data-type", type);
  validLink.setAttribute("data-timestamp", timestamp);
  validLink.innerHTML = "Verify";
  // edit button opens a type form, populated with chosen item
  validLink.addEventListener("click", function () {
    var type = this.getAttribute("data-type");
    var timestamp = this.getAttribute("data-timestamp");
    if (type == "applicant") {
      const applicant = applicants.filter(function (c) {
        return c && c.timestamp == timestamp;
      })[0];
      const index = $(applicants).index(applicant);
      applicants[index].verified = true;
      localStorage.setItem(
        formId + "-applicants",
        JSON.stringify(applicants)
      );
    } else if (type == "contact") {
      const contact = contacts.filter(function (c) {
        return c && c.timestamp == timestamp;
      })[0];
      const index = $(contacts).index(contact);
      contacts[index].verified = true;
      localStorage.setItem(formId + "-contacts", JSON.stringify(contacts));
    } else if (type == "location") {
      const location = locations.filter(function (l) {
        return l && l.timestamp == timestamp;
      })[0];
      const index = $(locations).index(location);
      locations[index].verified = true;
      localStorage.setItem(formId + "-locations", JSON.stringify(locations));
    }
  });


  var editLink = document.createElement("a");
  editLink.classList.add("edit");
  editLink.setAttribute("data-type", type);
  editLink.setAttribute("data-timestamp", timestamp);
  editLink.innerHTML = "Edit";
  // edit button opens a type form, populated with chosen item
  editLink.addEventListener("click", function () {
    toggleTypeForm(this.getAttribute("data-type"), true);
    editTypeItem(type, this.getAttribute("data-timestamp"));
  });

  var deleteLink = document.createElement("a");
  deleteLink.classList.add("delete");
  deleteLink.setAttribute("data-type", type);
  deleteLink.setAttribute("data-timestamp", timestamp);
  deleteLink.innerHTML = "Delete";
  // delete button confirms then deletes chosen item from lists
  deleteLink.addEventListener("click", function () {
    if (window.confirm("Are you sure you want to delete this item?")) {
      var type = this.getAttribute("data-type");
      var timestamp = this.getAttribute("data-timestamp");
      if (type == "applicant") {
        const applicant = applicants.filter(function (c) {
          return c && c.timestamp == timestamp;
        })[0];
        const index = $(applicants).index(applicant);
        applicants[index] = undefined;
        localStorage.setItem(
          formId + "-applicants",
          JSON.stringify(applicants)
        );
      } else if (type == "contact") {
        const contact = contacts.filter(function (c) {
          return c && c.timestamp == timestamp;
        })[0];
        const index = $(contacts).index(contact);
        contacts[index] = undefined;
        localStorage.setItem(formId + "-contacts", JSON.stringify(contacts));
      } else if (type == "location") {
        const location = locations.filter(function (l) {
          return l && l.timestamp == timestamp;
        })[0];
        const index = $(locations).index(location);
        locations[index] = undefined;
        localStorage.setItem(formId + "-locations", JSON.stringify(locations));
      }
      deleteItemFromLists(this.getAttribute("data-timestamp"));
      formHelpers.updateFromLocalStorage(formFields);
    }
  });

  el4.appendChild(validLink);
  el4.appendChild(editLink);
  el4.appendChild(deleteLink);

  row.appendChild(el1);
  row.appendChild(el2);
  row.appendChild(el3);
  row.appendChild(el4);
  list.appendChild(row);
}

function validatePageTypeForms(requiredFields, inputFields, currentTab) {
  var reqFields = requiredFields;
  var pageTypeForms = queryArray(
    ".tab[data-page='" + currentTab + "'] .type-form"
  );
  pageTypeForms.forEach(function (typeForm) {
    if (!typeForm.classList.contains("active")) {
      var typeFormFields = queryArray("[required]", typeForm);
      reqFields = reqFields.filter(function (reqField) {
        typeFormFields.indexOf(reqField) === -1;
      });
      inputFields = inputFields.filter(function (reqField) {
        typeFormFields.indexOf(reqField) === -1;
      });
    }
  });
  return reqFields;
}

window.formTypeHelpers = {
  filterTypeFormFields: filterTypeFormFields,
  appendToLists: appendToLists,
  createRow: createRow,
  validatePageTypeForms: validatePageTypeForms,
  getApplicants: getApplicants,
  getContacts: getContacts,
  getLocations: getLocations,
};
